<template>
  <div class="d-block text-center">
    <b-row class="my-1">
      <b-col sm="2" class="info-label">
        <label for="input-default">Project Name</label>
      </b-col>
      <b-col sm="8">
        <b-form-input
          id="input-default"
          v-model="name"
          placeholder="Enter project name"
        ></b-form-input>
      </b-col>
    </b-row>
    <b-row style="margin-top: 2em">
      <b-col sm="2" class="info-label">
        <label>Members</label>
      </b-col>
      <b-col sm="8">
        <!-- tag validator and invalid tag text is a hack 
        to remove the add button when an invalid user is used.
        bootstrap does not provid support for async validation or direct
        control of the add button. -->
        <b-form-tags
          v-model="members"
          class="members-form"
          input-id="members-form"
          placeholder="(Optional) Type username and press enter"
          :state="membersState"
          :tag-validator="() => !hasErrors"
          invalid-tag-text=""
          @input="tagsValidator"
        ></b-form-tags>
      </b-col>
    </b-row>
    <b-row v-if="hasErrors" class="text-danger mx-2 my-2">
      {{ error }}
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'ProjectInfoForm',
  props: {
    value: {
      type: Object,
      projectName: String,
      projectMembers: Array,
      errorMessage: String,
    },
    isValidationLoading: Boolean,
  },
  emits: ['input', 'validate-user'],
  computed: {
    name: {
      get() {
        return this.value.projectName;
      },
      set(projectName) {
        this.$emit('input', { ...this.value, projectName });
      },
    },
    members: {
      get() {
        return this.value.projectMembers;
      },
      set(projectMembers) {
        this.$emit('input', { ...this.value, projectMembers });
      },
    },
    error: {
      get() {
        return this.value.errorMessage;
      },
      set(errorMessage) {
        this.$emit('input', { ...this.value, errorMessage });
      },
    },
    hasErrors() {
      return !!this.error;
    },
    membersState() {
      if (this.members.length === 0 || this.isValidationLoading) {
        return undefined;
      }
      return !this.hasErrors;
    },
  },
  methods: {
    tagsValidator(tags) {
      const newTag = tags.at(-1);
      this.$emit('validate-user', newTag);
    },
  },
};
</script>

<style></style>
